 
import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

const main = { 
    getters,
    mutations,
    state,
    actions, 
    namespaced:true,
}
export default main